import * as identityStore from '@core/identity/store';
import { ActionReducerMap } from '@ngrx/store';

export const coreFeatureName = 'core';

export interface CoreState {
  [identityStore.identityStateKey]: identityStore.IdentityState;
}

export const coreReducers: ActionReducerMap<CoreState> = {
  [identityStore.identityStateKey]: identityStore.identityReducer,
};
